module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Minimum Margin Target")]), _vm._v(" "), _c('div', {
    staticClass: "margin-input-wrapper"
  }, [_c('input', {
    staticClass: "margin-input",
    attrs: {
      "type": "number",
      "step": "0.1",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.settings.defaultMarginPercentage
    },
    on: {
      "input": _vm.onMarginChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "percent-symbol"
  }, [_vm._v("%")])]), _vm._v(" "), _c('p', {
    staticClass: "form-hint"
  }, [_vm._v("Applied to all products unless overridden")]), _vm._v(" "), _c('p', {
    staticClass: "form-description"
  }, [_vm._v("\n      This is the minimum profit margin you want to maintain. Floor prices are calculated to protect this margin.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "toggle-wrapper"
  }, [_c('label', {
    staticClass: "toggle-label"
  }, [_vm._v("Alert when price approaches floor")]), _vm._v(" "), _c('div', {
    staticClass: "ui toggle checkbox",
    class: {
      checked: _vm.settings.floorPriceAlertEnabled
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.settings.floorPriceAlertEnabled
    },
    on: {
      "change": _vm.onToggleChange
    }
  }), _vm._v(" "), _c('label')])]), _vm._v(" "), _c('p', {
    staticClass: "form-hint"
  }, [_vm._v("Get notified when any product's margin drops below your target")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('strong', [_vm._v("How floor price is calculated:")]), _vm._v(" "), _c('div', {
    staticClass: "formula"
  }, [_vm._v("\n        " + _vm._s(_vm.formulaDescription) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_vm._v("\n        Example: (" + _vm._s(_vm.formatPrice(_vm.formulaExample.landed_cost)) + " + " + _vm._s(_vm.formatPrice(_vm.formulaExample.amazon_fees)) + ") ÷ (1-" + _vm._s((_vm.formulaExample.margin_percentage / 100).toFixed(2)) + ") = " + _vm._s(_vm.formatPrice(_vm.formulaExample.result)) + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Default Margin Target")]), _vm._v(" "), _c('span', {
    staticClass: "required-badge"
  }, [_vm._v("REQUIRED")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-385149a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricing-costs/DefaultMarginTargetSection.vue
// module id = 749
// module chunks = 2